import type { TextStyle } from 'pixi.js';

/** Combos extra on Pixi v8 `TextStyle` — stripped before constructing Pixi Text. */
export type TextColor = number | string;

export type TextStyleInput = Partial<TextStyle> & {
  backgroundColor?: TextColor;
};

export function splitTextStyle(style: TextStyleInput = {}): {
  backgroundColor: TextColor | undefined;
  pixiStyle: Partial<TextStyle>;
} {
  const { backgroundColor, ...pixiStyle } = style;
  return { backgroundColor, pixiStyle };
}

/**
 * Accept the common agent guesses: `0xffffff`, `"#fff"`, `"#ffffff"`, `"0xff0000"`.
 * Returns `null` when the value cannot be used as a Pixi fill color.
 */
export function parseTextColor(color: TextColor | undefined | null): number | null {
  if (color == null) return null;
  if (typeof color === 'number') {
    if (!Number.isFinite(color)) return null;
    return color >>> 0;
  }
  const raw = color.trim();
  if (!raw) return null;

  if (raw[0] === '#') {
    const hex = raw.slice(1);
    if (hex.length === 3 && /^[0-9a-fA-F]{3}$/.test(hex)) {
      return parseInt(hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2], 16);
    }
    if ((hex.length === 6 || hex.length === 8) && /^[0-9a-fA-F]+$/.test(hex)) {
      return parseInt(hex.slice(0, 6), 16);
    }
    return null;
  }

  if (/^0x[0-9a-fA-F]+$/.test(raw)) {
    return parseInt(raw, 16) >>> 0;
  }

  return null;
}
